module.exports = __webpack_public_path__ + "static/style-mockup-d42c61e2007c4b9e2d56880658c2dcc4.png";